import { InterpretRequest, InterpretResponse, VoiceCriteria } from "./types";

/**
 * Injected instead of importing axios/fetch directly: web attaches the
 * Firebase token via an axios interceptor, native fetches it per-call — the
 * two platforms get there differently, so this stays a seam, not a concrete
 * client. `post` receives the already-fetched token so a native
 * implementation that needs it explicitly still can.
 */
export type InterpretHttpDeps = {
  post: (path: string, body: InterpretRequest, token: string | null) => Promise<InterpretResponse>;
  getAuthToken: () => Promise<string | null>;
  /** Injected so core never touches `crypto` directly. */
  generateId: () => string;
};

export type InterpretArgs = {
  transcript: string;
  sttConfidence: number | null;
  sttModel: string;
  clientVersion: string;
  languageHint: string;
  existingCriteria: Partial<VoiceCriteria>;
};

const INTERPRET_PATH = "/Voice/Interpret";

export async function interpret(
  deps: InterpretHttpDeps,
  args: InterpretArgs,
): Promise<InterpretResponse> {
  const token = await deps.getAuthToken();

  const request: InterpretRequest = {
    transcript: args.transcript,
    sttConfidence: args.sttConfidence,
    sttModel: args.sttModel,
    clientVersion: args.clientVersion,
    languageHint: args.languageHint,
    referenceTimestamp: new Date().toISOString(),
    referenceTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    existingCriteria: args.existingCriteria,
    correlationId: deps.generateId(),
  };

  return deps.post(INTERPRET_PATH, request, token);
}
